module.exports = __webpack_public_path__ + "img/list.b39e5683.svg";